import React from 'react';
import MuiLink, { LinkProps as MuiLinkProps } from '@material-ui/core/Link';
import { withStyles } from '@material-ui/core/styles';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { TypographyProps as ExtendTypographyProps } from '@material-ui/core/Typography';

type TypographyProps = ExtendTypographyProps & { component: any };
type LinkProps = MuiLinkProps & {
  component: TypographyProps['component'];
};

const Link = withStyles<'root', {}, LinkProps>(
  (theme) => ({
    root: {
      ...theme.typography.body1,
      lineHeight: 1.2,
      fontWeight: theme.typography.fontWeightBold,
      display: 'inline-flex',
      alignItems: 'center',
      marginBottom: theme.spacing(2)
    },
    underlineHover: {
      '&:hover': {
        color: theme.palette.primary.main
      }
    },
    underlineAlways: {
      '&:hover': {
        color: theme.palette.primary.main
      }
    }
  }),
  { name: 'FdBackLink' }
)(MuiLink);

const BackLink: React.FC<LinkProps> = ({ children, ...rest }) => {
  return (
    <Link {...rest} color="textPrimary">
      <ArrowBackIosIcon fontSize="inherit" />
      {children}
    </Link>
  );
};

export default BackLink;
